/**
 * Trigger: tr_account_initial_balances_insert
 * Purpose: Update account balances when an initial balance is inserted
 * Table: account_initial_balances
 * Event: AFTER INSERT
 */
export const TR_ACCOUNT_INITIAL_BALANCES_INSERT = `
CREATE TRIGGER tr_account_initial_balances_insert
AFTER INSERT ON account_initial_balances FOR EACH ROW
BEGIN
  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_id, new.balance_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_id, new.balance_date);

  UPDATE account_balances
  SET initial_balance = new.initial_balance
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id;

  UPDATE account_daily_balances
  SET initial_balance = new.initial_balance
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id
    AND balance_date = new.balance_date;
END;
`;
